/* ============================================================
   Dropline theme — front-end behavior
   Vanilla JS, no dependencies.
   ============================================================ */
(function () {
  'use strict';

  var overlay = document.querySelector('[data-overlay]');

  /* ---------- Generic open/close for off-canvas panels ---------- */
  function openPanel(panel, trigger) {
    if (!panel) return;
    panel.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    panel.__trigger = trigger || null;
  }
  function closePanels() {
    document.querySelectorAll('[data-nav-drawer], [data-cart-drawer]').forEach(function (p) {
      p.setAttribute('aria-hidden', 'true');
      if (p.__trigger) p.__trigger.setAttribute('aria-expanded', 'false');
    });
    if (overlay) overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var navOpen = e.target.closest('[data-nav-open]');
    var cartOpen = e.target.closest('[data-cart-open]');
    var close = e.target.closest('[data-nav-close], [data-cart-close], [data-overlay]');

    if (navOpen) { openPanel(document.querySelector('[data-nav-drawer]'), navOpen); }
    else if (cartOpen) {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (drawer) { e.preventDefault(); openPanel(drawer, cartOpen); }
    }
    else if (close) { closePanels(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanels();
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('[data-accordion]').forEach(function (acc) {
    acc.addEventListener('click', function (e) {
      var q = e.target.closest('.faq__q');
      if (!q) return;
      var expanded = q.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(q.getAttribute('aria-controls'));
      q.setAttribute('aria-expanded', String(!expanded));
      if (panel) panel.style.maxHeight = expanded ? null : panel.scrollHeight + 'px';
    });
  });

  /* ---------- Modals (size guide, etc.) ---------- */
  function closeModals() {
    document.querySelectorAll('[data-modal]').forEach(function (m) { m.setAttribute('aria-hidden', 'true'); });
    if (!document.querySelector('[data-nav-drawer][aria-hidden="false"], [data-cart-drawer][aria-hidden="false"]')) {
      document.body.style.overflow = '';
    }
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-modal-open]');
    if (open) {
      var target = document.querySelector('[data-modal="' + open.getAttribute('data-modal-open') + '"]');
      if (target) { target.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('[data-modal-close]')) { closeModals(); return; }
    // Click on the backdrop (the modal element itself, not its panel) closes it
    var modal = e.target.closest('[data-modal]');
    if (modal && !e.target.closest('.modal__panel')) closeModals();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModals(); });

  /* ---------- Countdown timers ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var deadline = new Date(el.getAttribute('data-deadline')).getTime();
    if (isNaN(deadline)) return;
    var d = el.querySelector('[data-days]'),
        h = el.querySelector('[data-hours]'),
        m = el.querySelector('[data-mins]'),
        s = el.querySelector('[data-secs]');
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var revealed = false;
    var timer;

    function reveal() {
      if (revealed) return;
      revealed = true;
      var root = el.closest('[data-section-type]') || document;
      var pre = root.querySelector('[data-drop-pre]');
      var live = root.querySelector('[data-drop-live]');
      if (pre) pre.hidden = true;
      if (live) live.hidden = false;
    }

    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        diff = 0;
        if (el.getAttribute('data-on-end') === 'reveal') reveal();
        clearInterval(timer);
      }
      if (d) d.textContent = pad(Math.floor(diff / 86400000));
      if (h) h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (m) m.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (s) s.textContent = pad(Math.floor((diff % 60000) / 1000));
    }
    tick();
    timer = setInterval(tick, 1000);
  });

  /* ---------- Product variant selection (product page) ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
    var swatches = root.querySelectorAll('.swatch');
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.getAttribute('data-option-group');
        root.querySelectorAll('.swatch[data-option-group="' + group + '"]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');
      });
    });
  });

  /* ---------- AJAX add-to-cart + drawer refresh ---------- */
  function refreshCartUI() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
        var sub = document.querySelector('[data-cart-subtotal]');
        if (sub && window.Shopify) {
          sub.textContent = formatMoney(cart.total_price);
        }
      });
  }
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openCartAfterAdd() {
    refreshCartUI();
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) openPanel(drawer, null);
  }

  document.querySelectorAll('form[action$="/cart/add"], form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      // Progressive enhancement: only intercept if fetch is available
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          openCartAfterAdd();
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; }
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; }
          form.submit();
        });
    });
  });

  /* ---------- Order timeline ----------
     Hover is handled in CSS. This adds click/tap (touch has no hover),
     keyboard toggling, and the order-lookup panel. */
  document.querySelectorAll('[data-timeline]').forEach(function (tl) {
    var section = tl.closest('[data-section-type="order-timeline"]');
    var lookup = section ? section.querySelector('[data-lookup]') : null;

    function closeAll(except) {
      tl.querySelectorAll('.tl__node[data-open]').forEach(function (n) {
        if (n === except) return;
        n.removeAttribute('data-open');
        var b = n.querySelector('.tl__dot');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    tl.addEventListener('click', function (e) {
      var dot = e.target.closest('.tl__dot');
      if (!dot) return;
      var node = dot.closest('.tl__node');

      // First node opens the order-number field
      if (dot.hasAttribute('data-lookup-open') && lookup) {
        var showing = !lookup.hidden;
        lookup.hidden = showing;
        if (!showing) {
          var field = lookup.querySelector('input');
          if (field) field.focus();
          lookup.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      // Toggle this node's info, close the others
      var open = node.hasAttribute('data-open');
      closeAll(node);
      if (open) { node.removeAttribute('data-open'); dot.setAttribute('aria-expanded', 'false'); }
      else { node.setAttribute('data-open', ''); dot.setAttribute('aria-expanded', 'true'); }
    });

    document.addEventListener('click', function (e) {
      if (!tl.contains(e.target)) closeAll(null);
    });
    tl.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });

    // Bring the active stage into view on narrow screens
    var current = tl.querySelector('.tl__node[data-state="current"]');
    if (current && tl.scrollWidth > tl.clientWidth) {
      var wrap = tl.closest('.tl-scroll');
      if (wrap) wrap.scrollLeft = current.offsetLeft - wrap.clientWidth / 2 + current.offsetWidth / 2;
    }
  });

  /* ---------- Quick add from product cards ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick__btn[data-variant-id]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    if (!window.fetch) { window.location.href = btn.closest('.card').querySelector('.card__link').href; return; }

    var original = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = '✓';
        setTimeout(function () {
          btn.textContent = original;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1200);
        openCartAfterAdd();
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.textContent = original;
        btn.disabled = false;
      });
  });
})();
